import PageLayout from "layouts/PageLayout";
import TableData from "./tableData";

function Contact() {
  return (
    <PageLayout
      title={'Project Enquiry'}
    >
      <TableData />
    </PageLayout>
  );
}

export default Contact;
